export default function NotFound() {
  return (
    <div className="py-5xl text-center text-h1 font-bold text-gray-text">
      404 Not Found
    </div>
  );
}
